import Vue from 'vue'
import Vconsole from 'vconsole'
import common from '@/assets/js/common.js'
import * as api from '@/api/book.js'
var jsList
export default {
	isWeixin,
	baseConfig,
	wxShareInfo,
	vconsoleStatus
}
// 判断是否是微信浏览器
function isWeixin () {
	var ua = window.navigator.userAgent.toLowerCase()
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true
	} else {
		return false
	}
}
function baseConfig (params, callback, urlPath) {
	// 权限接口
	var url
	if (urlPath) {
		url = urlPath
	} else {
		url = window.location.href
	}
	api.getJsticket(url).then((res) => {
		var wxConfig = res.wxjssdk
		jsList = wxConfig.jsApiList
		wx.config({
			// debug: true,
			appId: wxConfig.appId,
			timestamp: wxConfig.timestamp,
			nonceStr: wxConfig.nonceStr,
			signature: wxConfig.signature,
			jsApiList: wxConfig.jsApiList
		})
		wxShareInfo(params, res)
		callback && callback(res)
		vconsoleStatus(res)
	})
}
function wxShareInfo (obj, user) {
	var opt = obj || {}
	var links = opt.link || common.Root + 'home'
	var title = opt.title || 'Better更好学苑'
	var desc = opt.desc || 'Be Better , Be Yourself .突破家庭与命运，重塑性格、情绪、关系，重获安全感，成为内心强大自由坚定的更好自己。'
	var imgUrl = opt.imgUrl || common.Root + 'static/images/icons/share.png'
	let hideMenu = ['menuItem:copyUrl', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:editTag', 'menuItem:delete', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
	let devUser = user.dev_user == 1 ? [] : hideMenu
	wx.ready(function () {
		wx.checkJsApi({
			jsApiList: jsList,
			success: function (res) {
				if (res) {
					console.log('title', title)
					console.log('desc', desc)
					console.log('imgUrl', imgUrl)
					wx.hideMenuItems({
						menuList: devUser
					})
					wx.onMenuShareAppMessage({
						title: title,
						desc: desc,
						link: links,
						imgUrl: imgUrl,
						success: function (v) {
							console.log('分享成功', v)
						},
						fail: function (e) {
							console.log('分享错误', e)
						},
						cancel: function () {
							// 用户取消分享后执行的回调函数
							console.log('用户取消分享后执行的回调函数')
						}
					})
					wx.onMenuShareTimeline({
						title: title,
						desc: desc,
						link: links,
						imgUrl: imgUrl,
						success: function (v) {}
					})
				}
			}
		})
	})
}
function vconsoleStatus (obj) {
  if (obj.dev_user === 1) {
	const vConsole = new Vconsole()
	Vue.use(vConsole)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/share.js